import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from 'src/app/core/security/authentication.service';
import { AlertService } from 'src/app/core/services/alert.service';
import { ApplicationConfigurationService } from 'src/app/core/services/applicationConfigurationService';

@Component({
  selector: 'app-ssc-configuration-edit',
  templateUrl: './ssc-configuration-edit.component.html',
  styleUrls: ['./ssc-configuration-edit.component.css'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class SscConfigurationEditComponent implements OnInit, OnDestroy {
  @Input()
  public loading = true;

  public appConfigs: any[] = [];
  public dataDictionary: any;
  public headerCols: any;
  public selectedRowForEdit: any;
  public lastChangedDateFilters: Date[] | null = null;

  public dataTypeDict: any = [
    { type: 'string', editor: 'text', decimal: 0 },
    { type: 'text', editor: 'text', decimal: 0 },
    { type: 'boolean', editor: 'boolean', decimal: 0 },
    { type: 'date', editor: 'date', decimal: 0 },
    { type: 'number', editor: 'numeric', decimal: 0 },
    { type: 'decimal', editor: 'numeric', decimal: 5 },
    { type: 'int', editor: 'numeric', decimal: 0 },
    { type: 'integer', editor: 'numeric', decimal: 0 },
    { type: 'bigint', editor: 'numeric', decimal: 0 }
  ];

  private dateTime = new Date();
  public yearRange = '2000:' + this.dateTime.getFullYear().toString();

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private authService: AuthenticationService,
    private appConfigService: ApplicationConfigurationService,
    private alertService: AlertService,
    private datePipe: DatePipe,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    if (!this.authService.isPrivacyNoticeAcknowledged) {
      this.router.navigate(['/privacy-notice']);
    }

    this.headerCols = [
      { field: 'DisplayName', header: 'Display Name' },
      { field: 'Description', header: 'Description' },
      { field: 'ConfigValue', header: 'Configured Value' },
      { field: 'ConfigDefaultValue', header: 'Default Value' },
      { field: 'LastChangedBy', header: 'Last Changed By' },
      { field: 'LastChangedDate', header: 'Last Changed Date' }
    ];

    this.getApplicationConfiguration();
  }

  ngOnDestroy() {
    this.modalService.dismissAll();
  }

  dateRangeFilter(value: any, filter: [Date, Date]): boolean {
    if (!filter || (!filter[0] && !filter[1])) {
      return true;
    }

    const val = new Date(value);
    const s = filter[0].getTime();
    let e: number;

    if (filter[1]) {
      e = filter[1].getTime() + 24 * 60 * 60 * 1000 - 1000;
    } else {
      e = s + 24 * 60 * 60 * 1000 - 1000;
    }

    return val.getTime() >= s && val.getTime() <= e;
  }

  clearFilters() {
    this.lastChangedDateFilters = null;
  }

  closeDateRangeFilter(dateComponent: any, filters: Date[] | null) {
    if (filters && filters[1]) {
      dateComponent.hideOverlay();
    }
  }

  openModal(editAppConfigModal: any, rowData: any) {
    this.selectedRowForEdit = JSON.parse(JSON.stringify(rowData));
    this.selectedRowForEdit.oldValue = this.selectedRowForEdit.ConfigValue;
    this.selectedRowForEdit.newConfigValue = '';
    this.selectedRowForEdit.comments = '';

    const dataType = this.dataTypeDict.filter((x) => x.type == this.selectedRowForEdit.DataType)[0];
    this.selectedRowForEdit.editor = dataType.editor;
    this.selectedRowForEdit.decimals = dataType.decimals;
    this.selectedRowForEdit.cellOptions = this.selectedRowForEdit.DictGroupId != null
      ? this.dataDictionary.filter((x) => x.DictGroup == this.selectedRowForEdit.DictGroupId)
      : [];

    this.modalService.open(editAppConfigModal, {
      size: 'lg',
      windowClass: 'animated fadeInDown fast',
      scrollable: true,
      backdrop: false
    });
  }

  resetToDefault(rowData: any) {
    this.selectedRowForEdit = JSON.parse(JSON.stringify(rowData));
    this.selectedRowForEdit.newConfigValue = this.selectedRowForEdit.ConfigDefaultValue;
    this.submitChanges();
  }

  clearChanges() {
    this.selectedRowForEdit.newConfigValue = '';
    this.selectedRowForEdit.comments = '';
  }

  submitChanges() {
    if (this.selectedRowForEdit.editor == 'date') {
      this.selectedRowForEdit.newConfigValue = this.datePipe.transform(
        this.selectedRowForEdit.newConfigValue,
        'yyyy-MM-dd'
      );
    }

    if (this.selectedRowForEdit.newConfigValue !== this.selectedRowForEdit.ConfigValue) {
      this.loading = true;
      const appConfig = {
        ConfigKey: this.selectedRowForEdit.ConfigKey,
        ConfigValue: this.selectedRowForEdit.newConfigValue,
        AppDefaultId: this.selectedRowForEdit.AppDefaultId,
        Notes: this.selectedRowForEdit.comments
      };

      this.appConfigService
        .updateApplicationConfiguration(appConfig)
        .then(() => {
          this.selectedRowForEdit = null;
          this.modalService.dismissAll();
          this.getApplicationConfiguration();
          this.loading = false;
           this.cdr.detectChanges();
        })
        .catch(() => {
          this.loading = false;
           this.cdr.detectChanges();
        });
    } else {
      this.selectedRowForEdit.newConfigValue = '';
      this.alertService.info('New value cannot be same as old value. Please enter a different value!');
    }
  }

  private getApplicationConfiguration() {
    this.loading = true;

    this.appConfigService
      .getApplicationConfiguration()
      .then((data: any) => {
        this.appConfigs = JSON.parse(JSON.stringify(data.Configurations));
        this.dataDictionary = JSON.parse(JSON.stringify(data.DataDictionary));
        this.loading = false;
        this.cdr.detectChanges();
      })
      .catch(() => {
        this.loading = false;
        this.cdr.detectChanges();
      });
  }
}